import React, {useEffect, useState} from "react";
import {CenterSpinner, useLazyQuery, useEvent} from "@soap/modules";
import {useFormatTimerString} from "../../../hooks/useFormatTimerString";
import {Button} from "../../ui/button";
import {useNavigate} from "react-router";

export function ViewSummary({e174, title, isPreview, e170}) {

    const viewStates = {
        loading: 1,
        loaded: 2
    };

    const [viewState, setViewState] = useState(viewStates.loading);
    const navigate = useNavigate();
    const [currentUserStudentId, setCurrentUserStudentId] = useState(null);

    const {fromSeconds} = useFormatTimerString();
    
    const [getUserProfile] = useLazyQuery("C166v1_GetUserProfile");
    
    useEvent({
        eventName: "E138v1_GotUserProfile",
        onEventReceived: (e138) => {
            setCurrentUserStudentId(e138.e138_StudentId || null);
        }
    });
    
    const hasOwnAccount = e170?.e170_Student?.e170_HasOwnAccount === true;
    const assessmentStudentId = e170?.e170_Student?.e170_StudentId;

    useEffect(() => {
        if (hasOwnAccount) {
            getUserProfile();
        }
    }, [getUserProfile, hasOwnAccount]);
    
    const shouldShowReturnToDashboard = hasOwnAccount && 
        currentUserStudentId != null && 
        assessmentStudentId != null && 
        currentUserStudentId === assessmentStudentId;
    
    useEffect(() => {
        if (e174 && viewState === viewStates.loading) setViewState(viewStates.loaded);
    }, [e174]);

    switch (viewState) {
        case viewStates.loading:
            return <CenterSpinner/>;
        case viewStates.loaded:
            return (
                <div className="space-y-8 text-center">
                    <div className="space-y-4">
                        <h2 className="text-2xl font-semibold text-gray-900">
                            Thank you for completing the assessment
                        </h2>
                        <h3 className="text-xl font-medium text-gray-700">
                            {title}
                        </h3>
                    </div>
                    
                    <div className="space-y-4">
                        {isPreview ? (
                            <p className="text-lg text-gray-700">
                                Preview completed successfully.
                            </p>
                        ) : (
                            <p className="text-lg text-gray-700">
                                Your results have been recorded.
                            </p>
                        )}
                        <p className="text-lg text-gray-700">
                            You completed {e174.e174_CompletedQuestions} of {e174.e174_TotalQuestions} questions
                            in {fromSeconds(e174.e174_TotalCompletionTimeInSeconds)}.
                        </p>
                        {shouldShowReturnToDashboard ? (
                            <div className="flex justify-center pt-4">
                                <Button 
                                    onClick={() => {
                                        navigate('/students/dashboard');
                                    }}
                                    className="px-6 py-2"
                                >
                                    Return to Dashboard
                                </Button>
                            </div>
                        ) : (
                            <p className="text-lg text-gray-700">
                                You may now close this browser window.
                            </p>
                        )}
                    </div>
                </div>
            );
    }
    
}
